import {
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Link as MuiLink,
  Typography,
  useTheme,
} from '@mui/material';
import Link from 'next/link';
import React from 'react';

export type BreadcrumbType = {
  title: string;
  href: string;
};

export type HeaderPageProps = {
  breadcrumb?: BreadcrumbType[];
  title?: string;
  subtitle?: string;
};

export function HeaderPage({
  breadcrumb = [],
  title,
  subtitle,
}: HeaderPageProps) {
  const theme = useTheme();
  return (
    <>
      <Box>
        <MuiBreadcrumbs separator="›" aria-label="breadcrumb">
          <Link key="1" href="/" passHref>
            <MuiLink underline="hover" color="inherit" variant="body2">
              home
            </MuiLink>
          </Link>
          {breadcrumb.map((item) => (
            <Link key={item.href} href={item.href} passHref>
              <MuiLink underline="hover" color="inherit" variant="body2">
                {item.title.toLowerCase()}
              </MuiLink>
            </Link>
          ))}
        </MuiBreadcrumbs>
      </Box>
      {title && (
        <Typography
          variant="h4"
          component="h1"
          sx={{
            color: theme.palette.secondary.main,
            fontWeight: theme.typography.fontWeightBold,
          }}
        >
          {title.toUpperCase()}
        </Typography>
      )}
      {subtitle && (
        <Typography
          variant="overline"
          component="h2"
          sx={{
            textTransform: 'uppercase',
          }}
        >
          {subtitle.toUpperCase()}
        </Typography>
      )}
    </>
  );
}
